import z from "zod";

export const simulateTurnSchema = z.object({
  user: z.string().min(1),
  expected: z.string().optional(),
});

export const simulateDatasetSchema = z.object({
  name: z.string().optional(),
  turns: z.array(simulateTurnSchema).min(1),
});

export type SimulateTurn = z.infer<typeof simulateTurnSchema>;
export type SimulateDataset = z.infer<typeof simulateDatasetSchema>;

export type ParseResult =
  | { ok: true; dataset: SimulateDataset }
  | { ok: false; error: string };

/** parseSimulateDataset validates already-parsed JSON and returns a readable error on failure. */
export function parseSimulateDataset(json: unknown): ParseResult {
  const result = simulateDatasetSchema.safeParse(json);
  if (!result.success) {
    const first = result.error.issues[0];
    const path = first?.path.join(".");
    const where = path ? `${path}: ` : "";
    return {
      ok: false,
      error: `${where}${first?.message ?? "invalid dataset"}`,
    };
  }
  return { ok: true, dataset: result.data };
}

/** parseSimulateDatasetText parses a raw JSON string first, then validates it. */
export function parseSimulateDatasetText(text: string): ParseResult {
  let json: unknown;
  try {
    json = JSON.parse(text);
  } catch {
    return { ok: false, error: "not valid JSON" };
  }
  return parseSimulateDataset(json);
}
